export default "__VITE_ASSET__lB2eZTQZ__"